import {
  ShowcaseProperty,
  Agent,
  Agency,
  ShowcaseDependency,
} from './index';

type ShowcasePropertyFields = 'description' | 'sale_price' | 'promo_sale_price' | 'website_latitude' | 'total_size_sqm' | 'project'

export class Showcase {
  friendly_id: string;
  subject: string;
  message: string;
  agent: Agent;
  agency: Agency;
  exposed_property_fields: ShowcasePropertyFields[] = [];
  showcases_properties: ShowcaseProperty[] = [];
  showcases_dependencies: ShowcaseDependency[] = [];
  showcase_snapshot_data: Showcase;
  agency_showcase_snapshot_data: Agency;
}
